import React from 'react';
import { Link } from 'react-router-dom';
import BmbCta from '../BmbCta';
import MkQr from '../MkQr';

// B12 — the second (and last) App Store badge on this page, far from the hero's.
const BmbFinal = ({ platform }) => (
  <section className="mk-final mk-final--bmb section" id="get" aria-labelledby="mk-bmbfinal-title">
    <div className="container">
      <div className="section-inner">
        <div id="mk-final-cta" className="mk-final__panel mk-final__panel--bmb reveal-scale-up" data-reveal-offset="0">
          <div className="mk-final__head">
            <h2 id="mk-bmbfinal-title" className="mk-h2">
              Breathe before you scroll.
            </h2>
            <p className="mk-lead">Bring Me Back is free to download for iPhone and Android.</p>
          </div>
          <div className="mk-final__single">
            <BmbCta variant="badges" placement="bmb_final" platform={platform} />
            <MkQr
              platform={platform}
              value="https://keepmeout.app/bring-me-back"
              title="QR code to the Bring Me Back page"
              caption="Scan with your phone — the page shows the right store."
            />
            <p className="mk-final__back">
              <Link className="mk-textlink" to="/">
                Back to Keep Me Out →
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BmbFinal;
